import { STORYBLOK_TYPES } from '~/lib/storyblok-types'
import PressListPage from '~/pages/press'

import { getPaginatedStaticPathsFunction } from '~/data/page-data'
import { getPressListStaticPropsFunction } from '~/data/press-list-page-data'

export default PressListPage

export const getStaticProps = getPressListStaticPropsFunction()
export const getStaticPaths = getPaginatedStaticPathsFunction({
  withPage: true,
  type: STORYBLOK_TYPES.PRESS_LIST_PAGE,
})
